export function StockNumberString(number) {
    if (number<=0) {
        return 'pd.notEnoughStock' //库存不足
    } else if (0<number&&number<=100) {
        return 'po.stockEnough.jinzhang' //库存紧张
    } else {
        return 'po.stockEnough' //库存充足
    }
    // if (number<=0) {
    //     return 'po.stockEnough' //库存充足
    // }  else {
    //     return 'po.stockEnough' //库存充足
    // }
}
